import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { MomentModule } from "angular2-moment";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { OwlDateTimeModule, OWL_DATE_TIME_FORMATS } from "ng-pick-datetime";
import { OwlMomentDateTimeModule } from "ng-pick-datetime-moment";
import { CKEditorModule } from "ng2-ckeditor";
import { BOMaterialModule } from "../material-module";
import { ImageInputComponent } from "../shared/components/imageInput/imageInput.component";
import { StrippedProgressBarComponent } from "../shared/components/strippedProgressBar/strippedProgressBar.component";
import { SignalBoConfiguration } from "../shared/configuration/SignalBoConfiguration";
import { EditorialImageCacheService } from "../shared/services/editorialImageCache.service";
import { PostI3Service } from "../shared/services/postI3.service";
import { ScheduleService } from "../shared/services/schedule.service";
import { SignalBoService } from "../shared/services/signalbo.service";
import { SharedModule } from "../shared/shared.module";
import { ConfirmationModalComponent } from "./components/scripts/confirmationModal.component";
import { SignalsComponent } from "./components/scripts/signals.component";
import { SignalsDeleteModalComponent } from "./components/scripts/signalsDeleteModal.component";
import { SignalsInsightsComponent } from "./components/scripts/signalsInsights.component";
import { SignalsInsightsCreateEditComponent } from "./components/scripts/signalsInsightsCreateEdit.component";
import { SignalsMessageCreateEditComponent } from "./components/scripts/signalsMessageCreateEdit.component";
import { SignalsMessagesComponent } from "./components/scripts/signalsMessages.component";
import { SignalsPublishScheduleModalComponent } from "./components/scripts/signalsPublishScheduleModal.component";
import { SignalsScheduledComponent } from "./components/scripts/signalsScheduled.component";
import { SignalsScheduledCreateEditComponent } from "./components/scripts/signalsScheduledCreateEdit.component";
import { SignalsSyncComponent } from "./components/scripts/signalsSync.component";
import { SignalsTradePlansComponent } from "./components/scripts/signalsTradePlan.component";
import { SignalsUserQuestionComponent } from "./components/scripts/signalsUserQuestion.component";
import { DataRelatedFactory } from "./services/dataRelatedFactory";
import { SignalsService } from "./services/signals.service";
import { SignalsConfigurationService } from "./services/signalsconfiguration.service";
import { SignalsI3Service } from "./services/signalsI3.service";
import { TradePlanService } from "./services/tradePlan.service";
import { ValidationsService } from "./services/validations.service";
import { TradingStudioRoutingModule } from "./tradingstudio-routing.module";

export const MY_MOMENT_FORMATS = {
  parseInput: "l LT",
  fullPickerInput: "l LT",
  datePickerInput: "LL",
  timePickerInput: "LT",
  monthYearLabel: "MMM YYYY",
  dateA11yLabel: "LL",
  monthYearA11yLabel: "MMMM YYYY",
};

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    NgbModule.forRoot(),
    TradingStudioRoutingModule,
    NgMultiSelectDropDownModule.forRoot(),
    MomentModule,
    CKEditorModule,
    OwlDateTimeModule,
    OwlMomentDateTimeModule,
    BOMaterialModule,
  ],
  declarations: [
    SignalsComponent,
    SignalsMessagesComponent,
    SignalsMessageCreateEditComponent,
    SignalsInsightsComponent,
    SignalsInsightsCreateEditComponent,
    SignalsScheduledComponent,
    SignalsUserQuestionComponent,
    SignalsScheduledCreateEditComponent,
    SignalsSyncComponent,
    SignalsTradePlansComponent,
    ConfirmationModalComponent,
    StrippedProgressBarComponent,
    ImageInputComponent,
    SignalsDeleteModalComponent,
    SignalsPublishScheduleModalComponent
  ],
  providers: [
    SignalsService,
    SignalBoService,
    ScheduleService,
    PostI3Service,
    EditorialImageCacheService,
    SignalsConfigurationService,
    SignalBoConfiguration,
    ValidationsService,
    DataRelatedFactory,
    SignalsI3Service,
    TradePlanService,
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_MOMENT_FORMATS },
  ],
  entryComponents: [ConfirmationModalComponent, SignalsDeleteModalComponent, SignalsPublishScheduleModalComponent],
})
export class TradingStudioModule {}



// WEBPACK FOOTER //
// ./src/app/tradingstudio/tradingstudio.module.ts